module.exports = __webpack_public_path__ + "img/icon-calendar.7ca7e8f1.svg";